import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import CustomFooter from '../components/Footer';
import { FaUserFriends, FaLocationArrow, FaGraduationCap, FaEnvelope, FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import { fetchProfileData } from '../api/auth';
import { useParams, Link, useNavigate } from 'react-router-dom';

const Profile = () => {
    const [profileData, setProfileData] = useState({});
    const { username } = useParams();
    const navigate = useNavigate();
    //console.log(username);

    useEffect(() => {
        const fetchData = async (username) => {
            try {
                if(username === undefined){username = "";}
                const profileData = await fetchProfileData(username);
                if(profileData.data.userState!=="" && profileData.data.userlga!==""){
                    profileData.data.stateLgaSeperator = ",";
                }else{
                    profileData.data.stateLgaSeperator = "";
                }
                setProfileData(profileData.data);
                if (profileData.userDoesNotExist) {
                    alert("User does not exist.");
                    navigate("/");
                }
            } catch (error) {               
                console.error("Error fetching user settings:", error);
            }
        };
        fetchData(username);
    }, [username, navigate]);

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Header />
            <div className="flex-grow container mx-auto p-6">
                <div className="bg-white rounded-lg shadow-md p-6">
                    {/* Profile Picture and Name */}
                    <div className="flex items-center">
                        <div className="w-20 h-20 rounded-full bg-gray-300 flex items-center justify-center text-gray-500 text-4xl">
                            <span className="sr-only">Profile Picture</span>
                        </div>
                        <div className="ml-4">
                            <h2 className="text-xl font-semibold">{profileData.firstname} {profileData.lastname}</h2>
                            <p className="text-sm text-grey-500">Codeforces: 
                                <a className="text-blue-500" href={"https://codeforces.com/profile/"+profileData.cfHandle}>@{profileData.cfHandle}</a></p>
                        </div>
                    </div>

                    {/* Contact Icons */}
                    <div className="items-center mt-4 space-x-4">
                        <h3 className="text-lg font-semibold text-gray-800">Basic Info</h3>
                        <div className="mt-4 flex items-start space-x-4">
                            <FaUserFriends className="text-purple-500 text-xl" />
                            <span className="text-blue-600">
                                <Link to={`/team/${encodeURIComponent(profileData.userTeam)}`} className="text-blue-500 hover:underline">
                                    {profileData.userTeam}
                                </Link>                               
                            </span>
                        </div>
                        <div className="mt-4 flex items-start space-x-4">
                            <FaLocationArrow className="text-blue-500 text-xl" />
                            <span className="text-gray-600">{profileData.userState}{profileData.stateLgaSeperator} {profileData.userlga}</span>
                        </div>
                        <div className="mt-4 flex items-start space-x-4">
                            <FaEnvelope className="text-green-500 text-xl" />
                            <span className="text-gray-600">{profileData.email}</span>
                        </div>
                        <div className="mt-4 flex items-start space-x-4">
                            <FaWhatsapp className="text-yellow-500 text-xl" />
                            <span className="text-gray-600">{profileData.whatsAppNumber}</span>
                        </div>
                    </div>

                    {/* Education Section */}
                    <div className="mt-8">
                        <h3 className="text-lg font-semibold text-gray-800">Education</h3>
                        <div className="mt-4 flex items-start space-x-4">
                            <FaGraduationCap className="text-green-500 text-2xl" />
                            <div>
                                <p className="text-sm text-gray-700">Institution: {profileData.institution}</p>
                                <p className="text-sm text-gray-700">Year: {profileData.yearOfStudy}</p>
                                <p className="text-sm text-gray-700">Field of Study: {profileData.fieldOfStudy}</p>
                            </div>
                        </div>
                    </div>

                    {/* Contact Section */}
                    <div className="mt-8">
                        <h3 className="text-lg font-semibold text-gray-800">Contact</h3>
                        <div className="mt-4 flex items-start space-x-4">
                            <FaPhoneAlt className="text-red-500 text-2xl" />
                            <p className="text-sm text-gray-700">{profileData.phoneNumber}</p>
                        </div>
                    </div>
                </div>
            </div>
            <CustomFooter />
        </div>
    );
};

export default Profile;
